import {TicketMessageEntity} from "@dropDesk/domain/entities/ticket/message/ticket_message.entity";
import {InternalChatMessageEntity} from "@dropDesk/domain/entities/internal_chat/messages/internal_chat_message_entity";

export enum MessagePosition {
  first = 'first',
  last = 'last',
  unique = 'unique'
}

export enum MessageBoxStatus {
  waiting = 'waiting',
  sent = 'sent',
  received = 'received',
  read = 'read'
}

export enum StatusMessageError {
  viewOnceError = 'view_once_error',
  largeMediaError = 'large_media_error',
  receiveMediaError = 'receive_media_error',
  sendMessageError = 'send_message_error',
  duplicatedError = 'duplicated_error'
}

export type ChatMessageEntity = TicketMessageEntity | InternalChatMessageEntity;